<template>
    <div>
        <v-btn outlined depressed color="secondary" @click="presentDialog" large>+ Add New Post</v-btn>
        <v-dialog persistent v-model="dialog" width="500" eager>
            <v-card>
                <v-card-title>
                    Add New Public Post
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                    <v-textarea
                        outlined
                        name="input-7-4"
                        label="Write your post..."
                        v-model="text"
                        :rules="nameRules"
                        :validate-on-blur="true"
                    ></v-textarea>  
                    </v-form>                  
                    <p class="text-subtitle-1 mb-2 primary--text"><v-icon color="primary">attach_file</v-icon>Add Photos or Video</p>
                    <vue-dropzone 
                        ref="assetImageDropzone" 
                        id="assetImageDropzone" 
                        :options="dropzoneOptions" 
                        @vdropzone-file-added="assetAdded"
                        @vdropzone-thumbnail="attachThumbnail"
                        :useCustomSlot=true
                    >
                        <v-icon x-large color="primary">backup</v-icon>
                        <div class="dropzone-custom-content">
                        <p class="text-h6 primary--text">Drag and drop to upload a file!</p>
                        <div class="text-subtitle1 primary--text">...or click to select a file from your computer</div>
                        </div>
                    </vue-dropzone>
                    <v-row>
                        <v-col v-for="(asset, index) in assets" :key="`asset${index}`" cols=4>
                            <v-hover v-slot:default="{ hover }">
                            <v-card elevation="0" class="rounded">
                            <v-img :src="asset.dataUrl || ''" aspect-ratio="1" class="info">
                                <v-scale-transition origin="center">
                                    <v-card v-if="asset.progress==100 && hover" elevation="0" class="primary" height="100%" style="opacity: 0.6">
                                        <p  class="text-right pa-0"><v-btn fab text small @click="removeAsset(index)"><v-icon class="text-right white--text">close</v-icon></v-btn></p>
                                         <v-row
                                            class="fill-height ma-0 mt-n14"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-icon color="white" size="40">{{asset.type=='video'? 'slideshow' : 'image'}}</v-icon>
                                        </v-row>
                                    </v-card>
                                </v-scale-transition>
                                <v-row
                                    v-if="asset.progress==100 && asset.type =='video'"
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                >
                                    <v-icon color="accent lighten-3" size="40">slideshow</v-icon>
                                </v-row>
                                <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                >
                                    <v-scale-transition>
                                    <v-card v-if="asset.progress!=100" elevation="0"  class="primary" style="opacity: 0.6" height="100%" width="100%">
                                        <p  class="text-right ma-0 pa-0"><v-btn fab text small @click="cancelUpload(index)"><v-icon class="text-right white--text">close</v-icon></v-btn></p>
                                        <v-row
                                            class="fill-height ma-0 mt-n10"
                                            align="center"
                                            justify="center"
                                        >
                                        <v-progress-circular
                                            :value="asset.progress"
                                            color="white"
                                            :rotate="-90"
                                            :size="80"
                                            :width="5"
                                        >
                                        <v-icon color="white" size="40">{{asset.type=='video'? 'slideshow' : 'image'}}</v-icon>
                                        </v-progress-circular>
                                        </v-row>
                                    </v-card>
                                    </v-scale-transition>
                                </v-row>                    
                            </v-img>
                            </v-card>
                            </v-hover>
                        </v-col>
                    </v-row>
                    <v-btn class="mt-10 text-body-1" block color="primary" large elevation="0" @click="addNewPost">Share</v-btn>
                    <v-btn block text color="primary" large class="mt-2 text-body-1" @click="closeDialog">Cancel</v-btn>
                    <v-dialog v-model="alertDialog" max-width="410">
                        <v-card>
                            <v-card-title>
                                Just a moment
                            </v-card-title>
                            <v-card-text>
                                {{alertMessage}}
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    color="primary"
                                    text
                                    @click="alertDialog=false"
                                >
                                    Okay
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {addPostDoc, deleteFileInStorage, getStorageRef, uploadFileInStorage} from "@/shared/firebase_utils";
let uuid = require('uuid');

export default {
    name: 'AddNewPostDialog',
    components: {
      vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            alertMessage: '',
            alertDialog: '',
            nameRules: [
                v => !!v || 'This field is required',
            ],
            dialog: false,
            text: '',
            assets: [],
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
                thumbnailWidth: 250,
                thumbnailHeight: 250,
                addRemoveLinks: false,
                acceptedFiles: '.jpg, .jpeg, .png, .mp4',
            },
            dataURL: 'Not Initialized',
        };
    },
    computed: mapGetters(['userProfile']),
    methods: {
        attachThumbnail(file, dataUrl) {
            this.assets.forEach((asset, index)=> {
                if(asset.dropzoneFileId == file.upload.uuid && asset.type == 'image') {
                    this.assets[index].dataUrl = dataUrl;
                }
            });
        },
        closeDialog() {
            this.assets.forEach((asset, index) => {
                this.assets[index].isCancelled = true;
            });
            this.assets.forEach((asset) => {
                if (asset.url != '') {
                    const assetRef = getStorageRef(`postAssets/${ asset.name }`);
                    deleteFileInStorage(assetRef);
                }     
            });
            this.dialog = false;
        },
        presentDialog() {
            this.$refs.form.reset();
            this.text = '';
            this.assets = [];
            this.dialog = true;
        },
        cancelUpload(index) {
            this.assets[index].isCancelled = true;
            //this.assets.splice(index, 1);
        },
        removeAsset(index) {
            const assetRef = getStorageRef(`postAssets/${ this.assets[index].name }`);
            deleteFileInStorage(assetRef);
            this.assets.splice(index, 1);
        },
        async addNewPost() {
            if (this.$refs.form.validate()) {
                let noOfUploadsInProgress = this.getNoOfUploadsInProgress();
                if (noOfUploadsInProgress > 0) {
                    if (noOfUploadsInProgress == 1)
                        this.alertMessage = 'Your file is being uploaded';
                    else
                        this.alertMessage = 'Your files are being uploaded';
                    this.alertDialog = true;
                    return;
                }
                try {
                    var reducedAssets = this.assets.reduce((filtered, asset) => {
                        if ((asset.url || '') != '') {
                            var newAsset = { type: asset.type, url: asset.url }
                            filtered.push(newAsset);
                        }
                        return filtered;
                    }, []);
                    await addPostDoc({
                        text: this.text,
                        businessProfileId: this.userProfile.businessProfileId,
                        createdAt: new Date(),
                        assets: reducedAssets
                    });
                    this.dialog = false
                } catch(e) {
                    console.log(e);
                }
            }
        },
        getNoOfUploadsInProgress() {
            let noOfUploadsInProgress = 0;
            this.assets.forEach((asset) => {
                if((asset.progress || 100) < 100)
                    noOfUploadsInProgress ++;
            });
            return noOfUploadsInProgress;
        },
        getFileType(fileName) {
            var extension = fileName.split('.').pop().toLowerCase();
            if (['jpg', 'jpeg', 'png'].includes(extension))
                return 'image';
            else if (['mp4'].includes(extension))
                return 'video';
            else
                return 'other';
        },
        async assetAdded(file) {
            try {
                this.$refs.assetImageDropzone.removeAllFiles();
                const fileType = this.getFileType(file.name);
                if (fileType =='other')
                    return;
                const assetIndex = this.assets.length;
                const assetName = `${uuid.v1()}.${fileType == 'image'? 'png' : 'mp4'}`; 
                this.assets.push({
                    name: assetName,type: fileType, 
                    progress: 0, url: '', 
                    isCancelled: false, 
                    dropzoneFileId: file.upload.uuid,
                    dataUrl: '',
                });

                //Get a firebase storage reference

                
                const assetRef = getStorageRef(`postAssets/${ assetName }`);
                var uploadTask = await uploadFileInStorage(assetRef, file);
                uploadTask.on('state_changed', (snapshot)=>{
                    switch (snapshot.state) {
                        case 'paused': // or 'paused'
                        console.log('Upload is paused');
                        break;
                        case 'running': // or 'running'
                        this.assets[assetIndex].progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        if (this.assets[assetIndex].isCancelled) {
                            uploadTask.cancel();
                            this.assets.splice(assetIndex, 1);
                            console.log("Cancelled");
                        }
                        break;
                    }
                }, (error) => {
                    // Handle unsuccessful uploads
                }, ()=> {
                    // Handle successful uploads on complete
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL)=> {
                        this.assets[assetIndex].url = downloadURL;
                    });
                });
            } catch (error) {
            console.log("Error while uploading an image");
            console.log(error)
            }
        },
    }
}
</script>
<style scoped>
.dz-image img {
    width: 100%;
    height: 100%;
}
.dropzone {
    height: 180px;
    border-radius: 4px;
} 
</style>